import { useState } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import RFForm from "../../../Form/RFForm";
import RFField from '../../../Form/RFField';
import { useEditorContext } from "../../Wysiwyg";
import ToolbarItem from "../ToolbarItem";
import DropZone from "react-dropzone";
import { ImageCard } from "../../../../commons/controls";
import { useId } from "react";
import ProgressButton from "../../../../commons/ProgressButton";

const ToolbarImage = ({
  icon = <i className="fa fa-picture-o" aria-hidden="true" />,
  imgProps,
  label = "Kép beszúrása",
}) => {
  const id = useId();
  const { editor, onImageUpload } = useEditorContext();

  const [loading, setLoading] = useState(false);
  const [formLink, setFormLink] = useState('');
  const [modal, setModal] = useState(false);
  const [file, setFile] = useState();

  const toggle = () => {
    setModal(!modal);
    setFile(undefined);
    setLoading(false);
    setFormLink('');
  };

  const handleSubmit = async () => {
    setLoading(true);
    if (file) {
      let src = "";
      if (onImageUpload) {
        try {
          src = await onImageUpload(file);
        } catch (err) {
          setLoading(false);
        }
      } else {
        src = `data:image/bmp;base64,${file.content}`;
      }

      if (src) {
        if(formLink === '' || !formLink) {
          editor
            .chain()
            .focus()
            .setImage({ src, alt: file.docname, ...imgProps })
            .run();
        } else {
          editor
          .chain()
          .focus()
          .setImageLink({
            href: formLink,
            src,
            alt: file.docname,
            ...imgProps,
          })
          .run();
        }
  

        toggle();
      }
    }

    setLoading(false);
  };

  const handleDrop = (files) => {
    const currentFile = files[0];
    if (currentFile) {
      const reader = new FileReader();
      reader.onload = () => {
        const fileAsBinaryString = reader.result;
        setFile({
          content: btoa(fileAsBinaryString),
          docname: currentFile.name,
          mime: currentFile.type ?? "application/octet-stream",
          length: currentFile.size,
          alt: "",
        });
      };
      reader.readAsBinaryString(currentFile);
    }
  };

  return (
    <>
      <ToolbarItem
        id={`image-toolbar-item-${id.replace(/\:/g, "")}`}
        tooltip={label}
        active={false}
        onToggle={toggle}
        icon={icon}
      />

      <Modal isOpen={modal} toggle={toggle} backdrop="static">
        <RFForm onSubmit={handleSubmit}>
          <ModalHeader toggle={toggle}>Kép beszúrása</ModalHeader>
          <ModalBody>
            <div>
              <RFField
                label={"Link: "}
                name={"formLink"}
                value={formLink} 
                onChange={(e => setFormLink(e.target.value))}
                // onChange={langHun ? (e => setFormCim(e.target.value)) : (e => setFormCimEng(e.target.value))}
                // required={langHun}
              /> 
            </div>
            {file ? (
              <ImageCard
                {...file}
                backgroundColor="transparent"
                noStyle
                poster
                onDeleteClick={() => setFile(undefined)}
                cardStyles={{ marginBottom: "0" }}
                style={{
                  objectFit: "cover",
                  width: "100%",
                }}
              />
            ) : (
              <DropZone
                onDrop={handleDrop}
                className="custom-dropzone"
                style={{ marginBottom: "0" }}
              >
                {({ getRootProps, getInputProps }) => (
                  <div
                    {...getRootProps({ className: "custom-dropzone" })}
                    style={{ marginBottom: "0" }}
                  >
                    <input {...getInputProps()} />
                    <div className="dropzone-text">Kép feltöltése!</div>
                  </div>
                )}
              </DropZone>
            )}
           
            
          </ModalBody>
          <ModalFooter>
            <ProgressButton color="primary" loading={loading} disabled={!file}>
              OK
            </ProgressButton>{" "}
            <Button color="secondary" onClick={toggle}>
              Mégsem
            </Button>
          </ModalFooter>
        </RFForm>
      </Modal>
    </>
  );
};

export default ToolbarImage;
